
<script lang="ts" setup>
import { toast } from '@/utils/global';
import { useGlobalData } from '@/utils/useGlobal';
import { ref } from 'vue';
import Popup from "@/components/global/Popup.vue";

defineProps({
  clx: {
    type: String,
    default: ""
  },
})

const { isPc, config } = useGlobalData()

const isShowWxPop = ref(false)

function showSocialPop(type: string) {
  const url = config.value.socialMedia[type]
  if (!url && type !== "weinxi") {
    toast('敬请期待~', 1000)
    return;
  }
  if (type === "weixin") {
    isShowWxPop.value = true;
    return;
  }
  if (isPc.value) {
    window.open(url, '', `width=1000,height=700,top=${(window.screen.height - 700) / 2},left=${(window.screen.width - 1000) / 2}`)
  } else {
    window.location.href = url
  }
}

const isOpen = ref(false)
function openContact() {
  isOpen.value = !isOpen.value
}

function close() {
  isShowWxPop.value = false;
}

</script>
<template>
  <div class="contact-wrap" :class="`${isOpen ? 'open' : ''} ${clx}`" >
    <div class="contact-content">
      <!-- <div class="contact-title" v-if="!isPc" @click="openContact">
        <i class="arrow"></i>
        <span class="text">关注我们</span>
      </div> -->
      <ul class="contact-list">
        <li class="contact-item active" @click="showSocialPop('bilibili')">
          <span class="icon-bilibili" />
        </li>
        <li class="contact-item" @click="showSocialPop('weibo')">
          <span class="icon-weibo" />
        </li>
        <li class="contact-item" @click="showSocialPop('weixin')">
          <span class="icon-weixin" />
        </li>
        <!-- <li class="contact-item" @click="showSocialPop('qqkj')">
          <span class="icon-qqkj" />
        </li> -->
        <li class="contact-item" @click="showSocialPop('douyin')">
          <span class="icon-dy" />
        </li>
        <li class="contact-item" @click="showSocialPop('xiaohongshu')">
          <span class="icon-xhs" />
        </li>
       
        <li class="contact-item active" @click="showSocialPop('qq')">
          <span class="icon-qq" />
        </li>
      </ul>
    </div>
  </div>
  <popup :value="isShowWxPop"  @input="close">
    <div class="popup_wrap">
      <div v-if="config.socialMedia.weixin" class="contact-pop">
        <div class="weixin-box">
          <img :src="config.socialMedia.weixin" alt="微信公众号" class="wx-img">
          <p class="wx-desc">{{ config.socialMedia.weixinDesc }}</p>
        </div>
        <div class="weixin-box">
          <img :src="config.socialMedia.weixinxiaochengxu" alt="微信小程序" class="wx-img">
          <p class="wx-desc">{{ config.socialMedia.weixinxiaochengxuDesc }}</p>
        </div>
      </div>
      <button class="close" @click="close"></button>
    </div>
  </popup>
</template>
<style lang="less" scoped>
.contact-content{
  display: flex;
  align-items: center;
}
.contact-list {
  display: flex;
  justify-content: space-between;
 
  .contact-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.4rem;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    & > span{
      display: block;
      width: 100%;
      height: 100%;
      transition: all .3s;
    }
    .icon-bilibili{
      background: url("~/images/media/bilibili.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-weibo{
      background: url("~/images/media/weibo.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-weixin{
      background: url("~/images/media/weixin.png") no-repeat center center;
      background-size: 100% 100%;
    }
    // .icon-qqkj{
    //   background: url("~/images/media/qqkj.png") no-repeat center center;
    //   background-size: 100% 100%;
    // }
    .icon-qq{
      background: url("~/images/media/qq.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-dy{
      background: url("~/images/media/douyin.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-xhs{
      background: url("~/images/media/xiaohongshu.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .wx-img {
    width: 0.96rem;
  }
}
.animate-share {
  animation: fadeInUpZoom 0.2s forwards;
}
.arrow{
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 0.15rem solid red;
  border-right: 0.1rem solid transparent;
  border-left: 0.1rem solid transparent;
  transition: all 0.2s;
  transform: rotate(90deg);
  
  &.open{
    transform: rotate(-90deg);
  }
}

.pc{
  .contact-wrap{
    position: fixed;
    bottom: 0.3rem;
    left: 0.18rem;
    z-index: 1;
  }
  .contact-list {
    height: 0.4rem;
  }
  .contact-item {
    &:hover{
      .icon-bilibili{
        background: url("~/images/media/bilibili-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-weibo{
        background: url("~/images/media/weibo-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-weixin{
        background: url("~/images/media/weixin-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-qqkj{
        background: url("~/images/media/qqkj-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-qq{
        background: url("~/images/media/qq-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-dy{
        background: url("~/images/media/douyin-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-xhs{
        background: url("~/images/media/xiaohongshu-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}
.wap{
  .contact-list {
    height: 0.6rem;
  }
  .contact-item {
    width: 0.6rem;
  }
}

.popup_wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 7rem;
  height: 4rem;
  padding: 0.6rem 0.5rem;
  font-size: 0.2rem;
  line-height: 1.6;
  color:#000;
  background-color: rgba(0, 0, 0, 0.5);
  border: 0.01rem solid #342e18;
  border-radius: 0.14rem;
  opacity: 0;
  animation: fadeUp 0.3s forwards;

  .contact-pop {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 0.14rem;
    
  }
  .weixin-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    margin: 0 13px;
    img{
      width: 100%;
    }
  }
  .wx-desc{
    width: 2rem;
    text-align: center;
    word-wrap: break-word;
  }
  .close {
    position: absolute;
    bottom: -1.28rem;
    left: 50%;
    width: 0.72rem;
    height: 1.27rem;
    cursor: pointer;
    background: url("~/images/pop/close.png") no-repeat left top / cover;
    transition: all 0.3s;
    transform: translateX(-50%);
    &:hover {
      transform: translateX(-50%) scale(1.02);
    }
  }
}

@keyframes fadeIn {

  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }

}

</style>
